import './index.scss';

import { useState } from "react";

import { useCommunity } from "contexts/community";

import { CommunityBanner, UserAvatar } from "@components/Community";

import { Button, Text } from "@fragments";

import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import { ArrowDropDownRounded, LinkRounded, ShareRounded } from "@mui/icons-material";
import * as Material from "@mui/material";



export default function Hero({ info, handleOpenUsers, loading }) {
    const { community: communityManagement } = useCommunity();

    const [loadingState, setLoadingState] = useState(false);

    const [subscribed, setSubscribed] = useState(info ? ['creator', 'owner', 'member'].includes(info.role) : false);

    async function handleSubscribeClick() {
        setLoadingState(true);
        await communityManagement.subscribe(info.id, () => {
            setSubscribed(true);
        });
        setLoadingState(false);
    }

    async function handleUnsubscribeClick() {
        setLoadingState(true);
        await communityManagement.unsubscribe(info.id, () => {
            setSubscribed(false);
        });
        setLoadingState(false);
    }

    function getSafeLink(link) {
        if (link?.includes('http')) return link;
        return 'https://' + link;
    }


    return (
        <div className="community-general-info mb-3">
            <div className="description">
                <CommunityBanner className="banner" size={108} banner={info?.banner} />

                <div className="pt-3" style={{ width: '100%' }}>
                    <div className="members-bar-content-inner">
                        <div className="community-title-container">
                            <div className="community-title">
                                <Text.h1 weight={500}>
                                    {info?.name}
                                </Text.h1>
                                {
                                    subscribed && info.role !== 'creator' && <Button
                                        tooltip="Gerenciar inscrição"
                                        color="inverse"
                                        size="small"
                                        loading={loadingState}
                                        endIcon={<ArrowDropDownRounded />}
                                        onClick={handleUnsubscribeClick}
                                    >
                                        Inscrito
                                    </Button>
                                }
                            </div>

                            {
                                !subscribed && info.role !== 'creator' && <Button
                                    tooltip="Se inscrever"
                                    color="inverse"
                                    size="small"
                                    loading={loadingState}
                                    endIcon={<ArrowDropDownRounded />}
                                    onClick={handleSubscribeClick}
                                >
                                    Se inscrever
                                </Button>
                            }

                            <div className="actions-row">
                                {
                                    info.isAdmin() && (
                                        <Button
                                            tooltip="Editar comunidade"
                                            color="overlay"
                                            onClick={() => {
                                                communityManagement.management.open(info);
                                            }}
                                            icon={<SettingsRoundedIcon />}
                                        />
                                    )
                                }
                                <Button
                                    tooltip="Compartilhar comunidade"
                                    onClick={() => {
                                        communityManagement.triggerShareModal(info.id);
                                    }}
                                    color="overlay"
                                    endIcon={<ShareRounded />}>
                                    Compartilhar
                                </Button>
                            </div>
                        </div>
                        <div className="communiy-description-info">
                            <div className="community-avatars">
                                {info.admins.slice(0, 3).map((admin, index) => (
                                    <div style={{ marginRight: '7px' }}>
                                        <UserAvatar size={24} user={admin} displayName={true} className="bsf-9 pr-1" style={{ padding: '4px', borderRadius: '50px' }} />
                                    </div>
                                ))}
                            </div>
                            {
                                info.admins.length > 3 && (
                                    <span style={{ opacity: 0.3, transform: 'translateY(1px)' }}>
                                        +{info.admins.length - 3} criadores •
                                    </span>
                                )
                            }
                            <span className='csf-5' style={{ transform: 'translateY(1px)' }} >
                                {window.helpers.pretty.int(info?.membersTotal)} membros
                            </span>

                            {info.isAdmin() && <Button
                                color="overlay"
                                variant="text"
                                size="small"
                                startIcon={<SettingsRoundedIcon />}
                                onClick={handleOpenUsers}
                            >
                                Gerenciar membros
                            </Button>}
                        </div>

                        <div className="mt-2 mb-2 text csf-2">
                            {
                                info?.description?.split("\n").map((line, key) => (
                                    <span className="description-line csf-4" key={key}>{line}</span>
                                ))
                            }

                            {
                                info?.links && (
                                    <div className="description-links mt-2">
                                        {
                                            info?.links?.map((attachment, key) => (
                                                <Button color="overlay"
                                                    size="small"
                                                    startIcon={<LinkRounded />}
                                                    key={key}
                                                    onClick={() => { window.open(getSafeLink(attachment.url), '_blank') }}
                                                >
                                                    {attachment.title}
                                                </Button>
                                            ))
                                        }
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}